import React, { useEffect, useState } from "react";
import { db, storage } from "../firebase/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useParams } from "react-router-dom";
import {
  Form,
  Input,
  Button,
  Card,
  Modal,
  Progress,
  Upload,
  Image,
  message,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function CampaignEditor() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);      // carregando dados iniciais
  const [saving, setSaving] = useState(false);       // salvando dados
  const [progressVisible, setProgressVisible] = useState(false);
  const [progress, setProgress] = useState(0);
  const [uploadingHero, setUploadingHero] = useState(false); // upload imagem principal

  // Carregar dados da campanha
  useEffect(() => {
    async function load() {
      const refDoc = doc(db, "campaigns", id);
      const snap = await getDoc(refDoc);

      if (snap.exists()) {
        form.setFieldsValue(snap.data());
      }
      setLoading(false);
    }
    load();
  }, [id, form]);

  // Upload da imagem principal para o Storage
  const handleHeroUpload = async (options) => {
    const { file, onSuccess, onError } = options;

    try {
      setUploadingHero(true);

      const fileRef = ref(
        storage,
        `campaigns/${id}/hero-${Date.now()}-${file.name}`
      );
      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);

      // seta o campo heroImage no formulário com a URL gerada
      form.setFieldsValue({ heroImage: url });

      setUploadingHero(false);
      onSuccess(url);
      message.success("Imagem enviada com sucesso!");
    } catch (err) {
      console.error(err);
      setUploadingHero(false);
      onError(err);
      message.error("Erro ao enviar imagem.");
    }
  };

  // Upload da imagem do celular
const handlePhoneUpload = async (options) => {
  const { file, onSuccess, onError } = options;

  try {
    const fileRef = ref(
      storage,
      `campaigns/${id}/phone-${Date.now()}-${file.name}`
    );

    await uploadBytes(fileRef, file);
    const url = await getDownloadURL(fileRef);

    form.setFieldsValue({ phoneImage: url });

    message.success("Imagem de celular enviada com sucesso!");
    onSuccess(url);
  } catch (err) {
    console.error(err);
    message.error("Erro ao enviar imagem do celular.");
    onError(err);
  }
};


  // Salvar alterações (com barra de progresso)
  const save = async (values) => {
    const refDoc = doc(db, "campaigns", id);

    // remove qualquer campo com valor undefined (Firestore não aceita)
    const cleanValues = {};
    Object.keys(values).forEach((key) => {
      if (values[key] !== undefined) {
        cleanValues[key] = values[key];
      }
    });

    try {
      setSaving(true);
      setProgress(0);
      setProgressVisible(true);

      await updateDoc(refDoc, cleanValues);

      // anima a barra de progresso por ~2 segundos
      let current = 0;
      const interval = setInterval(() => {
        current += 10;
        setProgress(current);
        if (current >= 100) {
          clearInterval(interval);
          setProgressVisible(false);
          setSaving(false);

          Modal.success({
            title: "Alterações salvas!",
            content: "As informações da campanha foram atualizadas com sucesso.",
          });
        }
      }, 200); // 200ms * 10 = ~2s
    } catch (err) {
      console.error(err);
      setSaving(false);
      setProgressVisible(false);
      Modal.error({
        title: "Erro ao salvar",
        content: "Ocorreu um erro ao tentar salvar as alterações.",
      });
    }
  };

  if (loading) {
    return (
      <div style={{ padding: 24, color: "#fff" }}>
        Carregando dados da campanha...
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <Card title={`Editar campanha: ${id}`}>
        <Form form={form} layout="vertical" onFinish={save}>
          <Form.Item name="title" label="Título">
            <Input />
          </Form.Item>

          <Form.Item name="topBarText" label="Texto do topo">
            <Input />
          </Form.Item>

          <Form.Item name="mainButtonText" label="Texto do botão">
            <Input />
          </Form.Item>

          <Form.Item name="whatsappLink" label="Link do WhatsApp">
            <Input />
          </Form.Item>

          <Form.Item name="discountBadgeText" label="Badge de desconto">
            <Input />
          </Form.Item>

          <Form.Item name="membersText" label="Texto de membros">
            <Input />
          </Form.Item>

          <Form.Item name="spotsText" label="Vagas restantes">
            <Input />
          </Form.Item>

          <Form.Item name="primaryColor" label="Cor principal (hex)">
            <Input />
          </Form.Item>

          <Form.Item name="bgColor" label="Cor de fundo (hex)">
            <Input />
          </Form.Item>

          {/* IMAGEM PRINCIPAL (heroImage) */}
          <Form.Item label="Imagem principal">
            {/* Upload para o Firebase Storage */}
            <Upload
              showUploadList={false}
              customRequest={handleHeroUpload}
              accept="image/*"
            >
              <Button icon={<UploadOutlined />} loading={uploadingHero}>
                {uploadingHero ? "Enviando..." : "Enviar imagem"}
              </Button>
            </Upload>

            {/* Campo para armazenar/editar a URL no Firestore */}
            <Form.Item name="heroImage" noStyle>
              <Input
                placeholder="Ou cole a URL da imagem aqui"
                style={{ marginTop: 8 }}
              />
            </Form.Item>

            {/* Preview da imagem atual */}
            {form.getFieldValue("heroImage") && (
              <div style={{ marginTop: 12 }}>
                <Image
                  src={form.getFieldValue("heroImage")}
                  alt="Preview imagem principal"
                  width={200}
                  style={{ borderRadius: 8 }}
                />
              </div>
            )}
          </Form.Item>

          {/* Imagem do celular (opcional, ainda usando texto/URL por enquanto) */}
         {/* UPLOAD IMAGEM DO CELULAR */}
<Form.Item label="Imagem do celular">
  <Upload
    showUploadList={false}
    customRequest={handlePhoneUpload}
    accept="image/*"
  >
    <Button icon={<UploadOutlined />}>
      Enviar imagem do celular
    </Button>
  </Upload>

  <Form.Item name="phoneImage" noStyle>
    <Input
      placeholder="Ou cole a URL da imagem do celular"
      style={{ marginTop: 8 }}
    />
  </Form.Item>

  {/* Preview da imagem do celular */}
  {form.getFieldValue("phoneImage") && (
    <div style={{ marginTop: 12 }}>
      <Image
        src={form.getFieldValue("phoneImage")}
        alt="Preview imagem celular"
        width={200}
        style={{ borderRadius: 8 }}
      />
    </div>
  )}
</Form.Item>


          <Button
            type="primary"
            htmlType="submit"
            loading={saving}
            disabled={saving}
          >
            Salvar
          </Button>
        </Form>
      </Card>

      {/* Modal de progresso */}
      <Modal open={progressVisible} footer={null} closable={false} centered>
        <p>Salvando alterações...</p>
        <Progress percent={progress} />
      </Modal>
    </div>
  );
}

export default CampaignEditor;
